/**
 * CORUN (application_id 148) のテーマカラー。
 * base = kikyo-500(#5B5FA8)、グラデーションは kikyo-600 → 500（白文字 4.5:1 を満たすため）。
 * ink.base / app.bg はブランド指定の「夜の藍 #1E1F3B」「青みの白 #F7F6FB」をそのまま使う。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const CORUN_PALETTE: ThemePalette = {
  appId: "148",
  appName: "CORUN",
  cyan: tw.kikyo,
  teal: tw.kikyo,
  gradient: { from: tw.kikyo[600], to: tw.kikyo[500] },
  ink: { base: "#1E1F3B", soft: "#41447C", mute: "#9193C5" },
  app: { bg: "#F7F6FB", card: "#FFFFFF" },
};
